(function () {
  'use strict';

  var logger = function(){ return new (require('../helpers/logger.js'))("SETTINGS").setColor("#585565"); }; // we need to use a function here to prevent circular dependencies
  var helper = require('./generic.js');
  var jwplayer = require("jwplayer");
  var debug = false;
  var deprecationWarnings = true;
  var curLang;
  var fallbackLang = 'en';
  var ignoredLoggers = [];
  // init the current language form html-lang-attribute
  setLanguageFromHtmlLang();


  function setLanguageFromHtmlLang(){
    curLang = getLanguageFromHtmlLang();
  }
  function getLanguageFromHtmlLang(){
    var lang = document.documentElement.lang;
    return lang;
  }

  module.exports = {

    /*********************
    *     Debugging      *
    **********************/

    debuggingEnabled: function debuggingEnabled(){
      return debug;
    },
    enableDebugging: function enableDebugging(){
      debug = true;
      logger().debug("Debugging enabled");
      return this;
    },
    disableDebugging: function disableDebugging(){
      logger().debug("Disabling Debugging...");
      debug = false;
      return this;
    },
    deprecationWarningsEnabled: function deprecationWarningsEnabled(){
      return deprecationWarnings;
    },
    enableDeprecationWarnings: function enableDeprecationWarnings(){
      deprecationWarnings = true;
      logger().debug("Deprecation Warnings enabled");
      return this;
    },
    disableDeprecationWarnings: function disableDeprecationWarnings(){
      logger().debug("Disabled Deprecation Warnings");
      deprecationWarnings = false;
      return this;
    },
    disableLoggingFor: function disableLoggingFor(identifier){
      logger().debug("disabling logging for ", identifier);
      if (identifier instanceof Array){
        ignoredLoggers = ignoredLoggers.concat(identifier);
      } else if (identifier instanceof String) {
        ignoredLoggers.push(identifier);
      } else {
        throw "unsupported type";
      }
      return this;
    },
    getIgnoredLoggers: function getIgnoredLoggers(){
      return ignoredLoggers;
    },


    /*********************
    *        I18N        *
    **********************/

    setCurrentLanguage: function setCurrentLanguage(lang){
      if (helper.undefOrNull(lang)){
        return;
      }
      lang = lang.toLowerCase().trim();
      logger().debug("setting current language to: ", lang);
      curLang = lang;
      return this;
    },
    currentLanguage: function currentLanguage(){
      if (helper.undefOrNull(curLang)){
        var fbLang = this.fallbackLanguage();
        logger().debug("currentLanguage has not been set! Using fallbackLanguage: ", fbLang);
        return fbLang;
      }
      return curLang;
    },
    getLanguageFromHtmlLang: getLanguageFromHtmlLang,
    setLanguageFromHtmlLang: setLanguageFromHtmlLang,
    fallbackLanguage: function fallbackLanguage(){
      if (helper.undefOrNull(fallbackLang)){
        return 'en';
      }
      return fallbackLang;
    },
    setFallbackLanguage: function setFallbackLanguage(lang){
      if (helper.undefOrNull(lang)){
        throw "You cannot set the fallback language to '"+lang+"'! A Fallback language must always be defined! Maybe you wanted to call setCurrentLanguage()?";
      }
      lang = lang.toLowerCase().trim();
      logger().debug("setting fallback language to: ", lang);
      fallbackLang = lang;
      return this;
    },

    /*********************
    *     AssetCore      *
    **********************/

    getAssetCoreBaseUrl: function getAssetCoreBaseUrl(){
      return this.assetCoreBaseUrl;
    },
    setAssetCoreBaseUrl: function setAssetCoreBaseUrl(url){
      if (helper.undefOrNull(url)){
        throw "You cannot set the AssetCore Base URL to '"+url+"'! The url has to be correct!";
      }
      if (!url.endsWith('/')){
        url = url + "/";
      }
      logger().debug("AssetCore Base URL set to: ", url);
      this.assetCoreBaseUrl = url;
      return this;
    },
    getAssetCoreBackendApiSuffix: function getAssetCoreBackendApiSuffix(){
      return this.assetCoreBackendApiSuffix;
    },
    setAssetCoreBackendApiSuffix: function setAssetCoreBackendApiSuffix(suffix){
      if (helper.undefOrNull(suffix)){
        throw "You cannot set the AssetCore Backend Suffix to '"+suffix+"'! The suffix has to be correct!";
      }
      logger().debug("AssetCore Base Backend Suffix set to: ", suffix);
      this.assetCoreBackendApiSuffix = suffix;
      return this;
    },


    /*********************
    *      JWPlayer      *
    **********************/

    setJwPlayerKey: function setJwPlayerKey(key){
      if (helper.undefOrNull(key)){
        throw "'"+key+"' is not a correct value for jwPlayer key!";
      }
      if (helper.undefOrNull(window.jwplayer)){
        window.jwplayer = jwplayer;
      }
      window.jwplayer.key = key;
      logger().debug("jwplayer.key has been set to ", key);
      return this;
    },
    getJwPlayerKey: function getJwPlayerKey(){
      if (helper.undefOrNull(window.jwplayer.key)){
        logger().error("Cannot play Video with JWPlayer! Key has not been set!");
      }
      return window.jwplayer.key;
    }


  };

}());



//////////////////
// WEBPACK FOOTER
// ./src/helpers/settings.js
// module id = 4
// module chunks = 0